import {stringToDateRange} from 'pages/dashboard/reports/detail/stringToDateRange';


export const generateMetricsAPIString = (params) =>{

    let urlParams = ``;

    if(params.accountUUID) urlParams = `accountUUID=${params.accountUUID}`;
    if(params.dateRange) urlParams = `${urlParams}&startDate=${params.dateRange.from}&endDate=${params.dateRange.to}`;
    if(params.sites) params.sites.forEach(site => urlParams = `${urlParams}&siteUUIDs=${site}`);
    if(params.countries) params.countries.forEach(country => urlParams = `${urlParams}&countries=${country}`);
    if(params.stories) params.stories.forEach(story => urlParams = `${urlParams}&storyUUIDs=${story}`);
    if(params.embeds) params.embeds.forEach(embed => urlParams = `${urlParams}&embedUUIDs=${embed}`);
    if(params.devices) urlParams = params.devices.length === 1 ? `${urlParams}&device=${params.devices.join()}` : urlParams;
    if(params.viewType) urlParams = `${urlParams}&viewType=${params.viewType}`;
    if(params.dataType) urlParams = `${urlParams}&dataType=${params.dataType}`;
    if(params.topRank) urlParams = `${urlParams}&topRank=${params.topRank}`;
    if(params.count) urlParams = `${urlParams}&count=${params.count}`;
    if(params.revenueType) urlParams = `${urlParams}&revenueType=${params.revenueType}`;

    return urlParams;
};

export const generateRunReportParamString = (params) => {
    let urlParams = ``;
    if(params.accountUUID) urlParams = `accountUUID=${params.accountUUID}`;
    if(params.reportUUID) urlParams = `${urlParams}&reportUUID=${params.reportUUID}`;
    if(params.name) urlParams = `${urlParams}&name=${params.name}`;

    if(params.dateRange === 'CUSTOM'){
        urlParams = !!params.customDateRange ? `${urlParams}&startDate=${params.customDateRange.from}&endDate=${params.customDateRange.to}` : urlParams;
    }else{
        let dateRange = stringToDateRange(params.dateRange);
        urlParams = !!dateRange ? `${urlParams}&startDate=${dateRange.from}&endDate=${dateRange.to}`: null;
    }
    if(params.sites) params.sites.forEach(site => urlParams = `${urlParams}&siteUUIDs=${site}`);
    if(params.metrics) params.metrics.forEach(metric => urlParams = `${urlParams}&metrics=${metric}`);
    if(params.dimensions) params.dimensions.forEach(dimension => urlParams = `${urlParams}&dimensions=${dimension}`);
    if(params.countries) params.countries.forEach(country => urlParams = `${urlParams}&countries=${country}`);
    if(params.devices) urlParams = params.devices.length === 1 ? `${urlParams}&devices=${params.devices.join()}` : urlParams;
    if(params.viewType) urlParams = `${urlParams}&viewType=${params.viewType}`;
    if(params.returnType) urlParams = `${urlParams}&returnType=${params.returnType}`;

    return urlParams;

};
